/**
 *
 * VideoCall
 *
 */

/* eslint-disable no-restricted-globals */

import "./styles.scss";

import MenuBar from "./components/MenuBar";
import React from "react";
import Strings from "utils/strings";
import { RotateSpinner } from "react-spinners-kit";
// @ts-ignore
import Variables from "styles/variables.scss";
import { connect } from "react-redux";

class VideoCall extends React.Component<any, any> {
	boundsTimeout: any | undefined;
	timeoutMenu: any | undefined;

	constructor(props: any) {
		super(props);

		this.state = {
			minimized: false,
			fullscreen: false,
			mobile: document.body.getBoundingClientRect()?.width <= 480 || false,
			showMobileOverlay: false
		};

		this.handleResize = this.handleResize.bind(this);
		this.handleMouseMove = this.handleMouseMove.bind(this);
		this.handleResize();
	}

	componentDidMount() {
		window.addEventListener("resize", this.handleResize);
		window.addEventListener("orientationchange", this.handleResize);
		window.addEventListener("mousemove", this.handleMouseMove);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
		window.removeEventListener("orientationchange", this.handleResize);
		window.removeEventListener("mousemove", this.handleMouseMove);
	}

	handleResize() {
		// @ts-ignore
		const orientation = (screen?.orientation || {}).type || screen?.mozOrientation || screen?.msOrientation;
		this.boundsTimeout = setTimeout(
			() =>
				this.setState({
					mobile:
						document.body.getBoundingClientRect()?.width <= 480 ||
						orientation === "portrait-primary" ||
						orientation === "portrait-secondary"
				}),
			200
		);
	}

	handleMouseMove(e: any) {
		const { openVideoCallModal } = this.props;
		const { mobile } = this.state;

		if (openVideoCallModal && !mobile) {
			const path = e.path || (e.composedPath && e.composedPath());

			const inside = path.some(
				(path: any) =>
					path.className === "VideoCallContent" ||
					path.className === "VideoCallContent __minimized" ||
					path.className === "VideoCallContent __fullscreen"
			);

			if (inside) {
				const elems = document.getElementsByClassName("MenuBar");
				if (elems) {
					for (const elem of elems) {
						elem.classList.add("--menu-visible");
					}
				}
			}

			clearTimeout(this.timeoutMenu);
			this.timeoutMenu = setTimeout(() => {
				const elems = document.getElementsByClassName("MenuBar");
				if (elems) {
					for (const elem of elems) {
						elem.classList.remove("--menu-visible");
					}
				}
			}, 1000);
		}
	}

	render() {
		const { room, openVideoCallModal, totalParticipants, videoSettings, user, onRetry, onClose } = this.props;
		const { fullscreen, mobile, showMobileOverlay } = this.state;

		let remoteClassName = "VideoEmptyRemoteClass";
		if (totalParticipants > 0) remoteClassName = "VideoPrimaryRemoteClass";

		let localClassName = "VideoEmptyLocalClass";
		if (totalParticipants > 0) localClassName = "VideoSecondaryLocalClass";

		if (!openVideoCallModal) return null;

		const localParticipant = room?.localParticipant?.identity;
		const remoteParticipant = room?.participants?.values?.().next().value?.identity;
		const isMinimized = videoSettings?.state === "minimized";
		if (isMinimized) {
			localClassName += " __disabled";
		}

		// connecting -> waiting (alone) -> in-call, or failed (App.videoConnect); the other party's name as the screen gave it
		const status = videoSettings?.status;
		const counterpart = videoSettings?.room?.user;
		const counterpartName = counterpart?.externalName || counterpart?.name || "";

		return (
			<div className="VideoCallContainer">
				<div className={`VideoCallMask${isMinimized ? " __disabled" : ""}`} />
				<div
					id="VideoCallContent"
					className={`VideoCallContent${isMinimized ? " __minimized" : ""}${
						fullscreen ? " __fullscreen" : ""
					}${showMobileOverlay ? " __mobileOverlay" : ""}`}
					onClick={() => {
						if (mobile) {
							this.setState(
								(prevState: any) => ({ showMobileOverlay: !prevState.showMobileOverlay }),
								() => {
									clearTimeout(this.timeoutMenu);
									this.timeoutMenu = setTimeout(() => {
										this.setState({ showMobileOverlay: false });
									}, 5000);
								}
							);
						}
					}}
				>
					<div className="VideoLoader">
						<RotateSpinner size={80} color={Variables.darkPrimaryColor} />
					</div>
					{status === "failed" && (
						<div className="VideoStatus __failed">
							<p>{Strings.video.connectFailed}</p>
							{videoSettings?.error?.message && <small>{videoSettings.error.message}</small>}
							<div className="VideoStatusOptions">
								<button
									className="VideoStatusButton --primary"
									onClick={(e: any) => {
										e.stopPropagation();
										if (typeof onRetry === "function") onRetry();
									}}
								>
									{Strings.video.tryAgain}
								</button>
								<button
									className="VideoStatusButton"
									onClick={(e: any) => {
										e.stopPropagation();
										if (typeof onClose === "function") onClose();
									}}
								>
									{Strings.generic.close}
								</button>
							</div>
						</div>
					)}
					{(status === "connecting" || status === "waiting") && (
						<div className="VideoStatus">
							<span className="VideoStatusDot" />
							<p>
								{status === "connecting"
									? Strings.video.connecting
									: Strings.formatString(Strings.video.waitingFor, counterpartName)}
							</p>
						</div>
					)}
					<div className="MediaContainer">
						<div ref="remoteMedia" id="remote-media" className={remoteClassName}>
							<div id="ParticipantPlaceholder" className="ParticipantPlaceholder">
								<div className="ParticipantAvatar">
									{Boolean(videoSettings?.room?.user?.photo) ? (
										<img src={videoSettings?.room?.user?.photo} alt="user avatar" />
									) : (
										<p>{videoSettings?.room?.user?.name?.substring(0, 1)}</p>
									)}
								</div>
							</div>
							{remoteParticipant && (
								<div className="VideoParticipant">
									<span>{remoteParticipant}</span>
								</div>
							)}
						</div>
						<div ref="localMedia" id="localMedia" className={localClassName}>
							<div id="LocalPlaceholder" className="LocalPlaceholder">
								<div className="LocalAvatar">
									{Boolean(user?.photo) ? (
										<img src={user?.photo} alt="user avatar" />
									) : (
										<p>{user?.name?.substring(0, 1)}</p>
									)}
								</div>
							</div>
							{localParticipant && (
								<div
									className={`VideoParticipant${
										localClassName === "VideoSecondaryLocalClass" ? " __secondary" : ""
									}`}
								>
									<span>{localParticipant}</span>
								</div>
							)}
						</div>
					</div>
					<div className={`VideoButtonsContainer __top${isMinimized ? " __minimized" : ""}`}>
						<MenuBar
							top
							isMinimized={isMinimized}
							showMobileOverlay={showMobileOverlay}
							mobile={mobile}
							onFullScreen={() => {
								const videoElement = document.getElementById("VideoCallContent");
								if (!document.fullscreenElement) {
									videoElement?.requestFullscreen();
									this.setState({ fullscreen: true });
								} else {
									document.exitFullscreen();
									this.setState({ fullscreen: false });
								}
							}}
							onExitFullScreen={() => this.setState({ fullscreen: false })}
							fullscreen={fullscreen}
							onDisconnect={() => {
								this.setState({ fullscreen: false, isMinimized: false });
							}}
						/>
					</div>
					{(!isMinimized && <div className="VideoWatermark" />) || null}
					<div className={`VideoButtonsContainer${isMinimized ? " __minimized" : ""}`}>
						<MenuBar
							showMobileOverlay={showMobileOverlay}
							mobile={mobile}
							bottom
							onDisconnect={() => {
								this.setState({ fullscreen: false, isMinimized: false });
							}}
						/>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	room: state.room,
	videoSettings: state.videoSettings,
	user: state.user
});

export default connect(mapStateToProps)(VideoCall);
